(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.assetInput
   */
  angular
    .module("akitabox.mobile.directives.assetInput", [
      "akitabox.core.services.asset",
      "akitabox.core.services.organization",
    ])
    .directive("abmAssetInput", AbmAssetInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.assetInput
   * @name AbmAssetInputDirective
   * @restrict E
   * @description
   * `abm-asset-input` creates a dropdown menu to allow for selection of the floors
   */

  /* @ngInject */
  function AbmAssetInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/asset-input/asset-input.html",
      controller: AbmAssetInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        placeholder: "@?",
        ngModel: "=",
        ngChange: "&?",
        floor: "=",
        room: "=",
        building: "=",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      vm.required = angular.isDefined(attrs.required);
      $scope.$watch("vm.building", function (newValue, oldValue) {
        resetNgModel(newValue, oldValue, "building");
        vm.placeholder = updatePlaceholder();
      });

      $scope.$watch("vm.floor", function (newValue, oldValue) {
        resetNgModel(newValue, oldValue, "level");
        vm.placeholder = updatePlaceholder();
      });

      $scope.$watch("vm.room", function (newValue, oldValue) {
        if (!vm.roomJustUpdatedInternally) {
          // Don't handle internal changes to room (i.e. vm.onItemChange)
          resetNgModel(newValue, oldValue, "room");
          vm.placeholder = updatePlaceholder();
        }
        vm.roomJustUpdatedInternally = false;
      });

      /**
       * Determines if ngModel should be set to null
       *
       * @param newValue
       * @param oldValue
       * @param type
       */
      function resetNgModel(newValue, oldValue, type) {
        if (!vm.ngModel) return; // We only want to reset ngModel if there is an ngModel

        // Determine if the newValue and the oldValue has actually changed.
        // Since this is an asset, it would see if the building, floor, or room have changed.
        // So value in this sense would usually be a building, floor, or room
        var hasChanged = (newValue && !oldValue) || (!newValue && oldValue);

        if (
          newValue &&
          oldValue &&
          Object.prototype.hasOwnProperty.call(newValue, "_id") &&
          Object.prototype.hasOwnProperty.call(oldValue, "_id")
        ) {
          hasChanged = hasChanged || newValue._id !== oldValue._id;
        } else {
          hasChanged = hasChanged || newValue !== oldValue;
        }

        // Only reset the model if the dependency has changed
        if (hasChanged) {
          // Always reset the asset if switching floors, rooms, or buildings
          vm.ngModel = null;
        }
      }

      /**
       * Updates the placeholder text to show a enabled and disabled mode
       *
       * @returns {*}
       */
      function updatePlaceholder() {
        if (!vm.building) {
          return "Building required";
        } else if (!vm.floor) {
          return "Floor required";
        }

        return vm.originalPlaceholder;
      }
    }
  }

  /* @ngInject */
  function AbmAssetInputController(
    // Angular
    $log,
    $q,
    // Services
    AssetService,
    ToastService,
    OrganizationService
  ) {
    var self = this;

    var allAssets = null;
    var assetRequest = null;
    var lastFloorId = self.floor ? self.floor._id : null;
    var lastRoomId = self.room ? self.room._id : null;

    if (angular.isUndefined(self.ngModel)) {
      return $log.error("<abm-asset-input> ng-model is unassigned");
    } else if (angular.isUndefined(self.floor)) {
      return $log.error("<abm-asset-input> floor is unassigned");
    } else if (angular.isUndefined(self.building)) {
      return $log.error("<abm-asset-input> building is unassigned");
    } else if (angular.isUndefined(self.room)) {
      return $log.error("<abm-asset-input> room is unassigned");
    }

    if (typeof self.noCache !== "boolean") self.noCache = true;

    self.isDisabled = isDisabled;
    self.querySearch = querySearch;
    self.onChange = onChange;
    self.organization = OrganizationService.getCurrent();

    self.loading = false;
    self.searchText = null;
    self.placeholder = self.placeholder || "Choose an asset";
    self.originalPlaceholder = self.placeholder;

    function isDisabled() {
      return !self.ngModel && (!self.building || !self.floor);
    }

    function querySearch(searchText) {
      if (!self.building || !self.floor) {
        return $q.resolve([]);
      }

      self.searchText = searchText;

      // Use initial request/data if the parameters haven't changed
      if (!hasFloorChanged() && !hasRoomChanged()) {
        if (allAssets) {
          // Filter and return on all assets if we've already fetched them
          return filterQuery(self.searchText, allAssets);
        }

        // Use the outstanding request, if we have one
        if (self.loading) {
          return assetRequest;
        }
      }

      var buildingId =
        self.building && self.building._id ? self.building._id : self.building;
      var floorId = self.floor && self.floor._id ? self.floor._id : self.floor;
      var roomId = self.room && self.room._id ? self.room._id : self.room;
      var data = {
        // Need to include values, so that parent room can be set on asset
        // change
        include_values: true,
        level: floorId,
      };

      if (roomId) {
        data.room = roomId;
      }

      // Update previous floor and room
      lastFloorId = floorId;
      lastRoomId = roomId;

      self.loading = true;
      assetRequest = AssetService.getAllTypeAheadByBuilding(
        buildingId,
        data,
        null,
        self.organization._id
      )
        .then(function (assets) {
          allAssets = assets;
          return filterQuery(self.searchText, allAssets);
        })
        .catch(function (err) {
          ToastService.showError(err);
          return [];
        })
        .finally(function () {
          self.loading = false;
        });

      return assetRequest;
    }

    function filterQuery(searchText, matches) {
      if (angular.isEmpty(searchText)) {
        return angular.copy(allAssets);
      }

      return matches.filter(function (match) {
        return match.name.match(new RegExp(searchText, "i"));
      });
    }

    /**
     * Determine if the floor has changed since the last request for assets was
     * made.
     *
     * @return {Boolean}   True if changed, false if not
     */
    function hasFloorChanged() {
      return self.floor ? lastFloorId !== self.floor._id : lastFloorId;
    }

    /**
     * Determine if the room has changed since the last request for assets was
     * made.
     *
     * @return {Boolean}   True if changed, false if not
     */
    function hasRoomChanged() {
      return self.room ? lastRoomId !== self.room._id : lastRoomId;
    }

    /**
     * Called when the asset is changed. Updates its parent room based on the newly selected asset.
     *
     * @param {Object} item   Newly selected asset
     */
    function onChange(item) {
      if (item && item.values && !self.room) {
        // Find the asset's room, and set it accordingly
        var buildingId =
          self.building && self.building._id
            ? self.building._id
            : self.building;

        AssetService.getRoom(buildingId, item.values).then(function (room) {
          self.room = room;
          self.roomJustUpdatedInternally = true;
        });
      }

      if (angular.isFunction(self.ngChange)) {
        self.ngChange({ value: item });
      }
    }
  }
})();
